import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.1564 5.902C20.3597 4.70809 19.3357 3.6788 18.1463 2.87597C17.5687 3.36477 16.8973 3.73508 16.3712 3.98699C15.5443 4.3829 14.6748 4.58887 13.8863 4.74658L12.6919 4.98546L12.2262 5.45113C10.4688 7.20849 10.4688 10.0577 12.2262 11.8151C13.9835 13.5725 16.8328 13.5725 18.5901 11.8151L19.0532 11.352L19.293 10.1533C19.4507 9.36474 19.6566 8.49523 20.0526 7.66837C20.3033 7.14488 20.6712 6.47757 21.1564 5.902Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.1815 1.82266C15.9611 1.95492 15.7313 2.07594 15.5075 2.1831C14.9152 2.4667 14.2484 2.63455 13.494 2.78542L9.86011 3.5122C8.18053 3.84812 6.63796 4.67368 5.42679 5.88484C2.03864 9.273 2.03864 14.7663 5.42679 18.1544L5.88511 18.6128C9.27327 22.0009 14.7666 22.0009 18.1547 18.6128C19.3659 17.4016 20.1914 15.859 20.5274 14.1794L21.2541 10.5455C21.405 9.79115 21.5728 9.12439 21.8564 8.53214C21.9598 8.31621 22.0761 8.09472 22.203 7.8814C22.717 9.15351 23 10.5437 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C13.4804 1 14.8924 1.29243 16.1815 1.82266Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.84101 7.29905C7.62471 6.51535 8.58874 5.94146 9.64415 5.625C8.36436 8.07559 8.75363 11.171 10.812 13.2293C12.8696 15.2869 15.9634 15.6766 18.4136 14.3985C18.097 15.4527 17.5234 16.4156 16.7405 17.1985C14.1334 19.8057 9.90644 19.8057 7.29933 17.1985L6.84101 16.7402C4.2339 14.1331 4.2339 9.90616 6.84101 7.29905Z"}}]};

const LogoCinema4DFilled = Vue.extend<IconProps>({
  name: 'LogoCinema4DFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-cinema4d-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoCinema4DFilled;
